export function transformUTGPcdsData(data){
    if(data && data.length > 0){
       return data.map((pcd)=>({
            name: pcd,
            id: pcd
        }))
    }
    return []
}